/* global publish, PUB_SUB_EVENTS */
(function () {
  'use strict';

  if (window.AOMVariantSwatch?.__loaded) return;
  window.AOMVariantSwatch = Object.assign(window.AOMVariantSwatch || {}, { __loaded: true });

  function aomTrack(n, p) { window.aomTrack?.(n, p); }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function dispatchVariantEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  function optionValueLabel(value) {
    if (typeof value === 'string') return value;
    if (value && typeof value === 'object') {
      return String(value.name || value.label || value.value || '');
    }
    return String(value || '');
  }

  function optionValueId(value) {
    return value && typeof value === 'object' && value.id != null ? String(value.id) : '';
  }

  function productOptionValueConfigs(productOptions, optIdx) {
    var values = (productOptions?.[optIdx]?.values) || [];
    return values.map(function (value) {
      return { label: optionValueLabel(value), id: optionValueId(value) };
    }).filter(function (value) { return value.label; });
  }

  function normalizeValueConfig(value) {
    if (typeof value === 'string') return { label: value };
    if (!value || typeof value !== 'object') return null;

    var label = optionValueLabel(value.label || value.name || value.value);
    if (!label) return null;

    return {
      label: label,
      id: value.id != null ? String(value.id) : '',
      color: typeof value.color === 'string' ? value.color : '',
      image: typeof value.image === 'string' ? value.image : '',
      w: Number(value.w) || 0,
      h: Number(value.h) || 0,
    };
  }

  // `default` is the old name for `pill`.
  function canonicalType(type) {
    if (!type || type === 'default') return 'pill';
    return type;
  }

  // Segmented holds only a few short values; past that the labels wrap or
  // squeeze. Mirrors the rule in snippets/aom-variant-swatch-group.liquid.
  function fitsSegmented(values) {
    if (!values || values.length < 2 || values.length > 4) return false;
    return values.every(function (v) { return String(v.label || '').length <= 14; });
  }

  // Bundle units are narrow and repeated, so the big types get their compact
  // form: a row of scale cards per unit would bury the bundle.
  function compactType(type, values) {
    if (type === 'scale-card') return fitsSegmented(values) ? 'segmented' : 'pill';
    return type;
  }

  function hasImages(values) {
    return (values || []).some(function (v) { return !!v.image; });
  }

  // Every product option comes back, configured or not. An option missing from
  // the config is a pill row; leaving it out is how a product configured for
  // Color used to show Size in Dawn's unrelated picker.
  function normalizeOptionEntries(config, productOptions) {
    var configuredOptions = (config && Array.isArray(config.options)) ? config.options : [];
    var seen = {};
    var out = [];

    configuredOptions.forEach(function (optCfg) {
      if (!optCfg || optCfg.divider === true || typeof optCfg.index !== 'number') return;
      if (seen[optCfg.index]) return;
      if (productOptions && productOptions.length && optCfg.index >= productOptions.length) return;
      seen[optCfg.index] = true;

      var type = canonicalType(optCfg.type);
      var values = Array.isArray(optCfg.values)
        ? optCfg.values.map(normalizeValueConfig).filter(Boolean)
        : [];

      // Values always follow the product's own option values, in the active
      // locale. The config is matched by option value id (survives a rename
      // or a translation), then base-language label, then position, the same
      // order as aom-variant-swatch-group.liquid, and only lends its
      // image/color/size. An id is used only when both sides carry one.
      var productValues = productOptionValueConfigs(productOptions, optCfg.index);
      if (productValues.length) {
        values = productValues.map(function (pv, i) {
          var cfg = (pv.id && values.find(function (v) { return v.id && v.id === pv.id; })) ||
            values.find(function (v) { return v.label === pv.label; }) || values[i] || {};
          return Object.assign({}, cfg, { label: pv.label, id: pv.id });
        });
      }

      if ((type === 'character' || type === 'round') && !hasImages(values)) type = 'pill';
      if (type === 'segmented' && !fitsSegmented(values)) type = 'pill';

      out.push({ index: optCfg.index, type: type, compactType: compactType(type, values), values: values });
    });

    (productOptions || []).forEach(function (_, optIdx) {
      if (seen[optIdx]) return;
      out.push({
        index: optIdx,
        type: 'pill',
        compactType: 'pill',
        values: productOptionValueConfigs(productOptions, optIdx),
      });
    });

    return out;
  }

  /* ── Canvas tint derivation ───────────────────────────────────────────────
     Samples every 4th pixel, skips near-transparent ones, averages RGB,
     then applies rgba(r, g, b, 0.18) as the thumb background.
     Falls back to rgba(0,0,0,0.06) when the image is too light (all channels
     > 210) or when canvas throws a cross-origin security error.
  ─────────────────────────────────────────────────────────────────────────── */
  function deriveTint(img, thumbEl) {
    try {
      var canvas = document.createElement('canvas');
      var size = 60; // downsample for speed
      canvas.width = size;
      canvas.height = size;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, size, size);
      var data = ctx.getImageData(0, 0, size, size).data;
      var r = 0, g = 0, b = 0, count = 0;
      // stride: 4 bytes/px × 4 = sample every 4th pixel
      for (var i = 0; i < data.length; i += 16) {
        if (data[i + 3] > 20) { // skip near-transparent
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          count++;
        }
      }
      if (!count) { thumbEl.style.background = 'rgba(0,0,0,0.06)'; return; }
      r = Math.round(r / count);
      g = Math.round(g / count);
      b = Math.round(b / count);
      thumbEl.style.background = (r > 210 && g > 210 && b > 210)
        ? 'rgba(0,0,0,0.06)'
        : 'rgba(' + r + ',' + g + ',' + b + ',0.18)';
    } catch (e) {
      thumbEl.style.background = 'rgba(0,0,0,0.06)';
    }
  }

  // Always create a fresh Image with crossOrigin set before src
  // to avoid canvas tainting from a previously cached non-CORS response.
  function applyTint(thumbEl) {
    var src = thumbEl.dataset.aomSwImg;
    if (!src) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { deriveTint(img, thumbEl); };
    img.onerror = function () { thumbEl.style.background = 'rgba(0,0,0,0.06)'; };
    img.src = src;
  }

  function createPill(options) {
    options = options || {};
    var type = canonicalType(options.type);
    var value = options.value || {};
    var label = value.label || '';
    var pill = document.createElement('button');

    pill.type = 'button';
    pill.className = 'aom-sw-pill aom-sw-pill--' + type + (options.selected ? ' is-selected' : '');
    pill.dataset.aomSwVal = label;
    pill.dataset.aomSwOptIndex = String(options.optionIndex);
    pill.setAttribute('role', 'option');
    pill.setAttribute('aria-selected', options.selected ? 'true' : 'false');

    if (options.dataset) {
      Object.keys(options.dataset).forEach(function (key) {
        pill.dataset[key] = options.dataset[key];
      });
    }

    if (type === 'round') {
      // Image only; the name is in the header and on the accessible label.
      pill.setAttribute('aria-label', label);
      var round = document.createElement(value.image ? 'img' : 'span');
      round.className = 'aom-sw-round' + (value.image ? '' : ' aom-sw-round--empty');
      if (value.image) {
        round.src = value.image;
        round.alt = '';
        round.width = 38;
        round.height = 38;
        round.loading = 'lazy';
        round.decoding = 'async';
      } else {
        round.setAttribute('aria-hidden', 'true');
      }
      pill.appendChild(round);
      return pill;
    }

    if (type === 'character' && value.image) {
      var thumb = document.createElement('span');
      thumb.className = 'aom-sw-thumb';
      thumb.dataset.aomSwImg = value.image;

      var img = document.createElement('img');
      img.src = value.image;
      img.alt = '';
      img.width = 36;
      img.height = 36;
      img.loading = 'lazy';
      img.decoding = 'async';

      thumb.appendChild(img);
      pill.appendChild(thumb);
      applyTint(thumb);
    } else if (type === 'color' && value.color) {
      var dot = document.createElement('span');
      dot.className = 'aom-sw-dot';
      dot.style.background = value.color;
      dot.setAttribute('aria-hidden', 'true');
      pill.appendChild(dot);
    }

    var labelEl = document.createElement('span');
    labelEl.className = 'aom-sw-pill__label';
    labelEl.textContent = label;
    pill.appendChild(labelEl);

    return pill;
  }

  // The class and inline style a row of values needs for its type.
  function decorateRow(row, type, valueCount) {
    type = canonicalType(type);
    row.classList.add('aom-sw-pills--' + type);
    if (type === 'segmented') row.style.setProperty('--aom-sw-count', String(valueCount));
  }

  /* ── Size guide dialog ───────────────────────────────────────────────────
     The button lives in an option header, the <dialog> beside the picker
     (snippets/aom-size-guide.liquid). Delegated on document because Dawn
     re-renders parts of the product section on every variant change. */
  if (!window.AOMVariantSwatch.__sizeGuideBound) {
    window.AOMVariantSwatch.__sizeGuideBound = true;
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-aom-sg-open]');
      if (opener) {
        var dialog = document.getElementById(opener.dataset.aomSgOpen);
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          dialog.showModal();
          aomTrack('aom_size_guide_open', { ui_element: 'size_guide', action_type: 'open' });
        }
        return;
      }
      // A click on the backdrop lands on the dialog element itself.
      if (e.target.classList && e.target.classList.contains('aom-sg') && e.target.open) {
        e.target.close();
      }
    });
  }

  window.AOMVariantSwatch = Object.assign(window.AOMVariantSwatch || {}, {
    applyTint: applyTint,
    createPill: createPill,
    decorateRow: decorateRow,
    normalizeOptionEntries: normalizeOptionEntries,
  });

  /* ── Per-instance init ────────────────────────────────────────────────────
     One call per [data-aom-sw] wrapper — safe for multiple products on a page
     (bundle, add-on, etc.).
  ─────────────────────────────────────────────────────────────────────────── */
  function initSwatch(wrap) {
    if (wrap.dataset.aomSwInitialized === 'true') {
      wrap._aomSwRefresh?.();
      return;
    }
    wrap.dataset.aomSwInitialized = 'true';

    var productId = wrap.dataset.aomSwProductId;
    var productUrl = wrap.dataset.aomSwProductUrl || window.location.pathname;
    var productInfo = wrap.closest('product-info');
    var productRoot = productInfo || wrap.closest('.shopify-section') || document;
    var allVariants = [];
    try {
      var variantsJson = wrap.querySelector('[data-aom-sw-variants-json]');
      allVariants = JSON.parse(variantsJson?.textContent || '[]');
    } catch (e) {}

    function getProductInfo() {
      return wrap.closest('product-info')
        || productInfo
        || document.querySelector('product-info[data-url="' + escapeSelector(productUrl) + '"]')
        || document.querySelector('product-info');
    }

    function getProductRoot() {
      return getProductInfo() || wrap.closest('.shopify-section') || productRoot || document;
    }

    function getProductFormRoot() {
      var root = getProductRoot();
      return root.querySelector('form[action*="/cart/add"]')
        || root.querySelector('product-form form')
        || document.querySelector('form[action*="/cart/add"]')
        || document.querySelector('product-form form');
    }

    // ── Current selections: keyed by option index (0-based) ──────────────
    var currentSelections = {};
    wrap.querySelectorAll('.aom-sw-pill.is-selected').forEach(function (pill) {
      currentSelections[parseInt(pill.dataset.aomSwOptIndex, 10)] = pill.dataset.aomSwVal;
    });

    function getHandledOptionIndexes() {
      return Array.from(wrap.querySelectorAll('[data-aom-sw-option-index]')).map(function (group) {
        return parseInt(group.dataset.aomSwOptionIndex, 10);
      });
    }

    function isHandledOptionIndex(index) {
      return getHandledOptionIndexes().indexOf(index) !== -1;
    }

    // Kick off canvas tinting for all character thumbnails
    wrap.querySelectorAll('[data-aom-sw-img]').forEach(applyTint);

    // ── Variant resolution ────────────────────────────────────────────────
    function findVariant(sels) {
      return allVariants.find(function (v) {
        return Object.keys(sels).every(function (i) {
          var value = v['option' + (Number(i) + 1)];
          if (typeof value === 'undefined' && Array.isArray(v.options)) {
            value = v.options[Number(i)];
          }
          return value === sels[i];
        });
      }) || null;
    }

    // ── Native variant-picker wiring ──────────────────────────────────────
    // Dawn's product-info listens for optionValueSelectionChange and owns the
    // section render. We mirror native option state, then publish the same
    // payload the theme expects.
    function getNativeOptionControls() {
      var root = getProductRoot();
      var variantSelects = root.querySelector('variant-selects');
      var candidates = Array.from((variantSelects || root).querySelectorAll(
        'fieldset, select[name^="options"], select[id*="SingleOptionSelector"], select[data-option-index]'
      ));
      return candidates;
    }

    function getControlSelectedValue(control) {
      if (!control) return '';
      if (control.matches?.('select')) {
        return control.value || control.options?.[control.selectedIndex]?.value || '';
      }
      var checked = control.querySelector('input:checked');
      return checked?.value || '';
    }

    function getControlSelectedOptionValueId(control) {
      if (!control) return '';
      if (control.matches?.('select')) {
        return normalizeOptionValueId(control.options?.[control.selectedIndex]?.dataset?.optionValueId);
      }
      return normalizeOptionValueId(control.querySelector('input:checked')?.dataset?.optionValueId);
    }

    function getControlSelectedTarget(control) {
      if (!control) return null;
      if (control.matches?.('select')) {
        var option = control.options?.[control.selectedIndex] || null;
        if (option && !option.id) option.id = 'aom-native-option-' + Math.random().toString(36).slice(2);
        return option || control;
      }
      return control.querySelector('input:checked') || control;
    }

    function seedSelectionsFromNativeControls() {
      getNativeOptionControls().forEach(function (control, idx) {
        if (typeof currentSelections[idx] !== 'undefined') return;
        var value = getControlSelectedValue(control);
        if (value) currentSelections[idx] = value;
      });
    }

    function refreshUnhandledSelectionsFromNativeControls() {
      getNativeOptionControls().forEach(function (control, idx) {
        if (isHandledOptionIndex(idx)) return;
        var value = getControlSelectedValue(control);
        if (value) currentSelections[idx] = value;
      });
    }

    seedSelectionsFromNativeControls();

    function getForm() {
      return getProductFormRoot();
    }

    function syncNativeControl(optIndex, val) {
      var controls = getNativeOptionControls();
      var control = controls[optIndex];
      if (!control) return null;

      if (control.matches?.('select')) {
        if (control.value !== val) control.value = val;
        return getControlSelectedTarget(control);
      }

      var input = control.querySelector('input[value="' + escapeSelector(val) + '"]');
      if (input && !input.checked) input.checked = true;
      return input || control;
    }

    function syncNativeSelections(changedOptionIndex) {
      var changedTarget = null;
      Object.keys(currentSelections).forEach(function (idx) {
        var target = syncNativeControl(Number(idx), currentSelections[idx]);
        if (Number(idx) === changedOptionIndex) changedTarget = target;
      });
      return changedTarget;
    }

    function syncVariantInput(variant) {
      if (!variant) return;
      var root = getProductRoot();
      var form = getForm();
      var inputs = [];
      if (form) {
        inputs = inputs.concat(Array.from(form.querySelectorAll('input[name="id"], input[name="variant_id"]')));
      }
      inputs = inputs.concat(Array.from(root.querySelectorAll(
        'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="variant_id"], product-form input[name="id"]'
      )));

      Array.from(new Set(inputs)).forEach(function (input) {
        if (String(input.value) !== String(variant.id)) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function normalizeOptionValueId(id) {
      if (!id) return '';
      return String(id).split('/').pop();
    }

    function getSelectedOptionValueIds() {
      var selectedOptionValues = getNativeOptionControls().map(getControlSelectedOptionValueId);
      wrap.querySelectorAll('[data-aom-sw-option-index]').forEach(function (grp) {
        var idx = parseInt(grp.dataset.aomSwOptionIndex, 10);
        var selected = grp.querySelector('[data-aom-sw-val].is-selected');
        if (selected?.dataset?.optionValueId) {
          selectedOptionValues[idx] = normalizeOptionValueId(selected.dataset.optionValueId);
        }
      });
      return selectedOptionValues.filter(Boolean);
    }

    function resolveSectionId() {
      var info = getProductInfo();
      if (info?.dataset?.section) return info.dataset.section;

      var section = wrap.closest('[id^="shopify-section-"]') || getProductRoot().closest?.('[id^="shopify-section-"]');
      if (section?.id) return section.id.replace(/^shopify-section-/, '');

      var dataSection = getProductRoot().querySelector?.('[data-section]');
      if (dataSection?.dataset?.section) return dataSection.dataset.section;

      return '';
    }

    function updateUrl(variant) {
      if (!variant || !window.history?.replaceState) return;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    function getFeaturedMediaId(variant) {
      return variant?.featured_media?.id || variant?.featured_media_id || variant?.featured_media;
    }

    function updateMediaGallery(variant, knownSectionId) {
      var mediaId = getFeaturedMediaId(variant);
      if (!mediaId) return false;

      var root = getProductRoot();
      var sectionId = knownSectionId || resolveSectionId();
      var activeMediaId = sectionId ? sectionId + '-' + mediaId : String(mediaId);
      var gallery = root.querySelector('media-gallery') || document.querySelector('media-gallery');

      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(activeMediaId, true);
        return true;
      }

      var selectors = [
        '[data-target="' + escapeSelector(activeMediaId) + '"]',
        '[data-media-id="' + escapeSelector(mediaId) + '"]',
        '#Thumbnail-' + escapeSelector(activeMediaId) + ' button',
        '#Slide-' + escapeSelector(activeMediaId),
      ];
      var target = selectors
        .map(function (selector) { return root.querySelector(selector) || document.querySelector(selector); })
        .find(Boolean);

      if (target && typeof target.click === 'function') {
        target.click();
        return true;
      }

      return false;
    }

    function publishDawnOptionChange(eventTarget, target, selectedOptionValues) {
      if (
        typeof publish !== 'function' ||
        typeof PUB_SUB_EVENTS === 'undefined' ||
        !PUB_SUB_EVENTS.optionValueSelectionChange ||
        !eventTarget ||
        !target ||
        !selectedOptionValues.length
      ) {
        return false;
      }

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: { target: eventTarget },
          target: target,
          selectedOptionValues: selectedOptionValues,
        },
      });

      return true;
    }

    function applyVariantFallback(variant, sectionId) {
      if (!variant) return;
      updateUrl(variant);
      updateMediaGallery(variant, sectionId);
      syncVariantInput(variant);
      dispatchVariantEvent('aom:variant-swatch:change', { variant: variant, productId: productId });
    }

    // ── Availability pass ─────────────────────────────────────────────────
    function updateAvailability() {
      wrap.querySelectorAll('[data-aom-sw-val]').forEach(function (pill) {
        var availableAttr = pill.dataset.aomSwAvailable;
        var unavailable;

        if (availableAttr === 'true' || availableAttr === 'false') {
          unavailable = availableAttr !== 'true';
        } else {
          var idx = parseInt(pill.dataset.aomSwOptIndex, 10);
          var testSel = Object.assign({}, currentSelections);
          testSel[idx] = pill.dataset.aomSwVal;
          var match = findVariant(testSel);
          unavailable = !match || !match.available;
        }

        // Styled, never disabled: see .aom-sw-pill.is-unavailable in the CSS.
        pill.classList.toggle('is-unavailable', unavailable);
      });
    }

    // ── Pill click handler ────────────────────────────────────────────────
    function selectPill(pill) {
      var optIndex = parseInt(pill.dataset.aomSwOptIndex, 10);
      var val = pill.dataset.aomSwVal;
      currentSelections[optIndex] = val;
      refreshUnhandledSelectionsFromNativeControls();

      // Update pill visual states within this group
      var group = wrap.querySelector('[data-aom-sw-option-index="' + optIndex + '"]');
      if (group) {
        group.querySelectorAll('[data-aom-sw-val]').forEach(function (p) {
          var active = p.dataset.aomSwVal === val;
          p.classList.toggle('is-selected', active);
          p.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        // Reactively update the label value
        var labelEl = group.querySelector('[data-aom-sw-selected-label]');
        if (labelEl) labelEl.textContent = val;
      }

      updateAvailability();

      var matchedVariant = findVariant(currentSelections);
      var sectionId = resolveSectionId();

      var nativeTarget = syncNativeSelections(optIndex);
      var selectedOptionValues = getSelectedOptionValueIds();
      if (!publishDawnOptionChange(nativeTarget, nativeTarget, selectedOptionValues)) {
        applyVariantFallback(matchedVariant, sectionId);
      }

      aomTrack('aom_swatch_select', {
        ui_element:   'variant_swatch',
        action_type:  'select',
        product_id:   productId,
        option_index: optIndex,
        option_value: val,
        variant_id:   matchedVariant ? matchedVariant.id : null,
      });
    }

    // Event delegation — one listener for all pills
    wrap.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-aom-sw-val]');
      if (pill && !pill.classList.contains('is-selected')) selectPill(pill);
    });

    // ── Hide native selects for options we're handling ────────────────────
    // Extracted as a function so it can be re-called after Dawn replaces
    // <variant-selects> via HTMLUpdateUtility.viewTransition (which swaps
    // the entire DOM node, making the fresh selects visible again).
    function hideNativeControls() {
      var optionControls = getNativeOptionControls();
      wrap.querySelectorAll('[data-aom-sw-option-index]').forEach(function (group) {
        var optIndex = parseInt(group.dataset.aomSwOptionIndex, 10);
        var control = optionControls[optIndex];
        if (!control) return;
        var target = control.closest?.('.product-form__input') || control;
        target.style.display = 'none';
      });
    }

    // Initial hide + availability pass
    wrap._aomSwRefresh = function () {
      seedSelectionsFromNativeControls();
      refreshUnhandledSelectionsFromNativeControls();
      hideNativeControls();
      updateAvailability();
    };
    hideNativeControls();
    updateAvailability();
  }

  function init() {
    document.querySelectorAll('[data-aom-sw]').forEach(initSwatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      init();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
